import { render, staticRenderFns } from "./MessagePreviewTip.vue?vue&type=template&id=168f7bcd&"
import script from "./MessagePreviewTip.vue?vue&type=script&lang=ts&"
export * from "./MessagePreviewTip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports